import React from 'react';
import { BacktestScenario } from '../../services/backtestScenariosService';

interface ScenarioPickerProps {
  scenarios: BacktestScenario[];
  activeScenarioId: string;
  onSelect: (id: string) => void;
}

export const ScenarioPicker: React.FC<ScenarioPickerProps> = ({
  scenarios,
  activeScenarioId,
  onSelect,
}) => {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '1.5rem' }}>
      {scenarios.map((s) => {
        const isActive = s.scenario_id === activeScenarioId;
        return (
          <button
            key={s.scenario_id}
            onClick={() => onSelect(s.scenario_id)}
            style={{
              padding: '0.5rem 1.25rem',
              borderRadius: '6px',
              border: isActive ? 'none' : '1px solid rgba(255,255,255,0.2)',
              backgroundColor: isActive ? '#3b82f6' : 'transparent',
              color: isActive ? 'white' : '#94a3b8',
              fontWeight: isActive ? 700 : 400,
              fontSize: '0.9em',
              cursor: 'pointer',
              transition: 'background-color 0.15s',
            }}
          >
            {s.title}
          </button>
        );
      })}
    </div>
  );
};
